import type { ProjectId, OutlookSpacesService } from 'owa-timestream-types';

const serviceMap = new Map<ProjectId, OutlookSpacesService>();

export function getProjectService(projectId: ProjectId) {
    return serviceMap.get(projectId);
}

export function registerProjectService(projectId: ProjectId, service: OutlookSpacesService) {
    serviceMap.set(projectId, service);
}

export function deregisterProjectService(projectId: ProjectId) {
    serviceMap.delete(projectId);
}
